import React from 'react';
import * as model from './model';

type OronaLineContext = {
    user: model.User,
    loggedIn:boolean,
    token: string,
    language: string,
    update(delta: model.GetUserResponse): void,
    updateLanguage(lang: model.Lang): void
  };
  
export default React.createContext<OronaLineContext>({
    user: {
        firstName: "",
        lastName: "",
        emailAddress: ""
    },
    loggedIn: false,
    token: "",
    language: "",
    update: (n) => {
      throw new Error('update() not implemented');
    },
    updateLanguage: (n) => {
      throw new Error('updateLanguage() not implemented');
    }
  });